import React from 'react';
import { Card } from "react-bootstrap";
import faceAndrasKornai from "../../assets/img/faceAndrasKornai.jpg";
import ShowMoreText from "react-show-more-text";
import proj_KornaiA_anonymization from "../../assets/img/proj_KornaiA_anonymization.png";

const Andras_Kornai_anonymization = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_KornaiA_anonymization} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={faceAndrasKornai}
              /* this will be the text on the banner */
              alt="Contribution Evaluation & Privacy in Federated Learning"
            />{" "}
            <p className="text7">András Kornai</p>
            <br />
            <p className="text8">
              Senior Scientific Advisor{" "}
            </p>
            <p className="text8">HUN-REN Institute for Computer Science and Control </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            There are three projects related to the recent NVIDIA <a href="https://kornai.com/soft_indexing.pdf">grant</a>. We will use low-end 
            NVIDIA <a href="https://www.nvidia.com/en-eu/autonomous-machines/embedded-systems/jetson-orin/">hardware</a>, to index large (multi-terabyte) data 
            collections by means of training LLMs on these collections: the card will have direct (NFS) read access to the entire filesystem, and the 
            goal is to create the index at the speed of disk i/o. There are three relatively independent tasks.
            <ol>
                <li>
                    Anonymization. NVIDIA offers software libraries for this goal, the task is to investigate its effectiveness 
                    on heterogeneous texts, part English, part German, part Hungarian, in multiple file formats.  Part of the 
                    goal is to detect the language and the format of the files, including detection of material already archived 
                    (but not encrypted), following symbolic links etc.
                </li>
                <li>
                    Indirect indexing. The soft indexes created in the project offer three orders of magnitude compression, from 
                    terabyte filesystems to gigabyte indexes. An important project goal is further compression of these indexes, 
                    ideally down to the megabyte level, so that the chances of answering a query from a given doubly-compressed 
                    index could be well estimated based on the much smaller indirect index so created.
                </li>
                <li>
                    Two of the cards will be located in Hungary over a relatively fast optical network, one will be in the US 
                    (Boston University) and one likely in Austria (Uni Graz) -- these will only have megabit-speed connections. 
                    We assume that each Jetson card will maintain a direct  index of the file system it is attached to, but also 
                    indirect indexes of the other cards it is mesh-adjacent to. The task is investigating the effectiveness of 
                    federated search over the entire mesh.
                </li>
            </ol>
            Students participating in these tasks can all expect to gain familiarity with the LLMs and NVIDIA hardware and software. 
            Task 1 (anonymization) is a key pre-deployment step in almost all information retreival and digital library applications, 
            and language ID and format detection remain critical machine learning tasks from bioinformatics to scientific data retrieval. 
            Task 2 (indirect indexing) requires data compression, branch-and-bound search, and other classical computer science algorithms, 
            and offers a deeper understanding of word- and document vectors. Finally, Task 3 is best suited for students interested in mesh 
            networking as well as federated data storage and info retreival.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Andras_Kornai_anonymization;